import React from "react";
import "./SkillSet.css";

function SkillSet() {
  return (
    <div className="rs-video style2 pt-5 mt-4 pb-5 mb-4">
      <div className="container">
        <div className="video-skill">
          <div className="row margin-0">
            <div className="col-lg-6 padding-0 md-mb-50">
              <div className="skillsets-part">
                <div className="sec-title4 mb-40">
                  <span className="sub-title white-color pb-15">Skillsets</span>
                  <h2 className="title white-color">
                    We have expert team with different skillsets
                  </h2>
                </div>
                <div className="cl-skill-bar style2 solutions mt-5 mb-5">
                  <span className="skillbar-title">Prosperity</span>
                  <div className="skillbar" data-percent="90">
                    <p className="skillbar-bar" style={{ width: "90%" }}></p>
                    <span className="skill-bar-percent">90%</span>
                  </div>
                  <span className="skillbar-title">Quality</span>
                  <div className="skillbar" data-percent="85">
                    <p className="skillbar-bar" style={{ width: "85%" }}></p>
                    <span className="skill-bar-percent">85%</span>
                  </div>
                  <span className="skillbar-title">Guaranty</span>
                  <div className="skillbar" data-percent="95">
                    <p className="skillbar-bar" style={{ width: "95%" }}></p>
                    <span className="skill-bar-percent">95%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 padding-0">
              <div className="video-wrap">
                <div className="video-btn primary text-center">
                  <a className="popup-videos" href="">
                    <i className="fa fa-play"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SkillSet;
